import React, { Component } from 'react'
import Modal from '../Modal'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { color, pxToRem } from '../../utils'
import { Button, FormControl, Input, InputError, Select } from '../Form'
import CurrencyFormat from 'react-currency-format'
import { measureActions, productMapActions } from '../../actions'

const ActionButton = styled(Button)`
  margin-top: 20px;
  margin-left: 2.5%;
  border: 0;
  background-color: ${props => props.save ? color.primary : color.danger};
`

const Wrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  gap: 0px 16px;
`

const WrapperInputWithError = styled(FormControl)`
  padding: 0;
  width: 100%;
`

const WrapperActions = styled(Wrapper)`
  justify-content: flex-end;
`

const WrapperSelect = styled(FormControl)`
  width: 100%;
  display: inline-block;
  color: ${color.secondary};
  padding: 0;
  label {
    font-size: ${pxToRem(16)};
    height: ${pxToRem(50)};
    line-height: ${pxToRem(50)};
  }
`

class UpdateAmountModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      submitted: false,
      displayAmount: '',
      amount: null,
      measureId: null,
      measure: null,
      productId: null,
      amountError: null,
      measureError: null
    }
  }

  componentDidMount() {
    this.props.fetchMeasures()
  }

  componentWillReceiveProps(props) {
    const { id, amount = '', measure_id } = props.productMap
    const selectedMeasure = measure_id && props.measuresList.find(measure => measure.id === measure_id)
    const measure = selectedMeasure ? {
      value: (selectedMeasure || {}).id || null,
      label: (selectedMeasure || {}).description || null
    } : null

    this.setState(state => ({
      ...state,
      displayAmount: amount,
      amount,
      measureId: measure_id,
      measure,
      productId: id,
      amountError: null,
      measureError: null
    }))
  }

  handleAmount = values => {
    this.setState(state => ({
      ...state,
      amountError: null,
      displayAmount: values.formattedValue,
      amount: values.floatValue,
    }))
  }

  handleMeasure = measure => {
    this.setState(state => ({
      ...state,
      measureId: (measure || {}).value || null,
      measure,
    }))
  }

  validateInputs = (amount, measureId) => {
    this.setState(state => ({
      ...state,
      amountError: null,
      measureError: null
    }))

    var isValid = true

    if (!amount && !measureId) return isValid

    if (!amount) {
      this.setState(state => ({
        ...state,
        amountError: 'Não pode ficar em branco'
      }))

      isValid = false
    }

    if (!measureId) {
      this.setState(state => ({
        ...state,
        measureError: 'Não pode ficar em branco'
      }))

      isValid = false
    }

    return isValid
  }

  handleSubmit = event => {
    event.preventDefault()
    this.setState({ submitted: true })
    const {productId: id, amount, measureId } = this.state
    const { areaId } = this.props

    if (this.validateInputs(amount, measureId)) {
      this.props.changeProductAmount({
        id,
        areaId,
        amount,
        measureId
      })
      this.props.closeModal()
    }
  }

  render () {
    const {
      open,
      closeModal,
      productMap,
      fetch_errors,
      fetching,
      measuresFetching,
      measuresList
     } = this.props
    const { name } = productMap
    const loading = false

    const { handleAmount, handleMeasure, handleSubmit } = this
    const {
      displayAmount,
      measureId,
      measure,
      amount,
      amountError,
      measureError,
      submitted
    } = this.state

    const disabledSaveAction = productMap.measure_id === measureId && productMap.amount === amount

    return (
      <Modal
        title={`Atualizar quantidade: ${name}`}
        loading={fetching.productMap || fetching.changeAmount}
        open={open}
        error={fetch_errors.productMap}
        closeMethod={closeModal}
      >
      <form onSubmit={handleSubmit} id={'form'}>
        <Wrapper>
          <WrapperInputWithError>
            <CurrencyFormat
              width="100%"
              thousandSeparator="."
              decimalSeparator=","
              decimalScale={5}
              allowNegative={false}
              customInput={Input}
              label="Quantidade"
              onValueChange={(values) => {
                handleAmount(values)
              }}
              value={displayAmount || ''}
              disabled={loading}
            />
            {submitted && amountError && <InputError>{amountError}</InputError>}
          </WrapperInputWithError>

          <WrapperSelect>
            <Select
              isClearable
              isLoading={measuresFetching}
              withPortal
              placeholder={'Unidade de medida'}
              defaultValue={measure}
              onChange={event => {
                handleMeasure(event)
              }}
              options={measuresList.map(measure => {
                return {
                  label: measure.description,
                  value: measure.id
                }
              })}
            />
            {submitted && measureError && <InputError>{measureError}</InputError>}
          </WrapperSelect>
        </Wrapper>

        <WrapperActions>
          <ActionButton type={'button'} onClick={closeModal}>
            Cancelar
          </ActionButton>
          <ActionButton type={'submit'} form={'form'} save={true} disabled={disabledSaveAction}>
            Salvar
          </ActionButton>
        </WrapperActions>

      </form>

    </Modal>
    )
  }
}

const mapStateToProps = state => ({
  productMap: state.productMap.productMap,
  fetching: state.productMap.fetching,
  fetch_errors: state.productMap.fetch_errors,
  areaId: state.auth.areaId,
  measuresFetching: state.measure.fetching,
  measuresList: state.measure.items,
  measuresLoading: state.measure.loading,
  measuresErrors: state.measure.error
})

const mapDispatchToProps = dispatch => {
  return {
    fetchMeasures: () => {
      dispatch(measureActions.fetchMeasures())
    },
    changeProductAmount: ({ id, areaId, amount, measureId }) => {
      dispatch(productMapActions.changeProductAmount({ id, areaId, amount, measureId }))
    },
  }
}

measureActions

export default connect(mapStateToProps, mapDispatchToProps)(UpdateAmountModal)



// WEBPACK FOOTER //
// ./src/components/ProductModal/UpdateAmountModal.js